import React, { useEffect, useState } from 'react';
import { RouteFormatter } from '../../routes';
import { LISTING_WORK_CONTENT, LISTING_WORK_CONTENT_MBL } from '../../consts/listings.consts';
import SniffButton from '..//sniff-button';
import './how-works.scss';

export const RenderHowWorks = ({ isMobile, name, action, addedClass = '', subObj, listings }) => {
    const [sniffWorks, setSniffWorks] = useState(LISTING_WORK_CONTENT_MBL);
    const parkType = subObj?.seoTitle.toLowerCase() || 'dog parks';
    const title = listings
        ? `How do Sniffspot's private ${subObj?.seoTitle.toLowerCase() || 'dog parks'} work?`
        : `How do ${name}'s private ${parkType} work?`;

    useEffect(() => {
        !isMobile && setSniffWorks(LISTING_WORK_CONTENT);
    }, [isMobile]);

    return (
        <div className={`sniff-work ${addedClass}`}>
            <div className="l-container">
                <h2 className="snif-m1 snif-l1-pc snif-semibold mb-2">{title}</h2>
                <div className="snif-work-list">
                    {sniffWorks.map((L, i) => (
                        <div key={i} className="work-list-item">
                            <L.Icon />
                            <div>
                                <h2 className="snif-p snif-semibold mb-1">{L.title}</h2>
                                <div className="snif-p">
                                    <L.desc />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {action && (
                    <p className="text-center mt-5 pt-1">
                        <a href={RouteFormatter.listings({})}>
                            <SniffButton size="lg" block="mobile">
                                Explore spots near me
                            </SniffButton>
                        </a>
                    </p>
                )}
            </div>
        </div>
    );
};

export default RenderHowWorks;
